import type { App, DirectiveBinding } from 'vue';

import type { ConversationResultDTO } from '@nora-monorepo/nora-api-client';

import type { ConversationState } from '#nora-chat-ui/states';
import { chatCan } from '#nora-chat-ui/utils/permission';

export type PermissionCheck
  = | string
    | {
      permission: string;

      conversation?: ConversationResultDTO;
      conversationId?: string;
      conversationState?: ConversationState;
    };

export function installAccessManagement(app: App): void {
  app.directive('chat-can', canDirective);
}

function canDirective(element: HTMLElement, binding: DirectiveBinding<PermissionCheck>): void {
  const permissionCheck: PermissionCheck = binding.value;
  const permission
    = typeof permissionCheck === 'string'
      ? permissionCheck
      : permissionCheck.permission;

  const conversationId = getConversationIdFromPermissionCheck(permissionCheck);

  if (chatCan(permission, conversationId)) {
    show(element);

    return;
  }

  hide(element);
}

function hide(element: HTMLElement): void {
  element.style.setProperty('display', 'none', 'important');
}

function show(element: HTMLElement): void {
  element.style.removeProperty('display');
}

function getConversationIdFromPermissionCheck(permissionCheck: PermissionCheck): string | null {
  if (typeof permissionCheck === 'string') {
    return null;
  }

  if (permissionCheck.conversation) {
    return permissionCheck.conversation.id;
  }
  else if (permissionCheck.conversationId) {
    return permissionCheck.conversationId;
  }
  else if (permissionCheck.conversationState) {
    return permissionCheck.conversationState.conversationListResult.id;
  }

  return null;
}
